import {
  IAccountValidationRequest,
  IAccountValidationResponse,
  IPayAccountRequest,
  IPayAccountResponse,
} from "domains/cashless/aggregates/IPaymentAccount";
import { ICashlessRepository } from "domains/cashless/interfaces/ICashlessRepository";
import {
  ICardCashless,
  ICardGroupDiscounts,
  IConfirmRecordRequest,
  IConfirmRecordResponse,
  IGetPendingRecords,
  IPendingRecordsResposne,
} from "../../../domains/cashless/aggregates/ICardCashless";
import {
  IOpenAccountRequest,
  //IOpenAccountResponse,
} from "../../../domains/cashless/aggregates/IOpenAccount";
import { IExtract } from "../../../domains/cashless/aggregates/IExtract";
import { IOrderPad } from "../../../domains/cashless/aggregates/IOrderPad";
import { IHttpRepository } from "../../interfaces/IHttpRepository";
import { getGlobalAddLog } from "../appInsights/AppInsights";
import { HttpRepository } from "./_HttpRepository";
import {
  CommandEletronicExtract,
  ExtractRepository,
} from "./ExtractRepository";
import { DadosConsumoPOS, PedidoPos, responseSyncPedidoPos } from "../../interfaces/PedidoMeep";
import { IRechargeAccountRequest } from "domains/cashless/aggregates/IRechargeAccount";
import { Order } from "domains/order/agreggates/order/Order";
import { FinancialTransactionModel } from "domains/order/agreggates/payment/FinancialTransactionModel";
import { TransactionType } from "domains/order/agreggates/payment/transactionType";
import { GetError } from "utils/GetError";
import { orderToPedidoPOS, orderToConsusmeOrder, consumeOrderToLog } from "./_Parses";

const addLog = getGlobalAddLog();
const extractService = ExtractRepository();

export const CashlessRepository = (): ICashlessRepository => {
  const httpRepository: IHttpRepository = HttpRepository();

  const getCardData = async (
    id: string,
    tag: string
  ): Promise<ICardCashless> => {
    addLog && addLog("Request getCardData", { tag });
    return await httpRepository.getAsync<ICardCashless>(
      `/dispositivo/cartaocashless/${id}/${tag}`
    );
  };

  const getNominalExtractByNickname = async (nickname: string): Promise<any> => {
    addLog && addLog("Request getNominalExtractByNickname", { nickname });
    return await httpRepository.getAsync<any>(
      `/dispositivo/cartaocashless/apelido/${nickname}`
    );
  };

  const getGroupData = async (
    localClienteId: string,
    historicoAssociacaoId: string,
    tag: string
  ): Promise<ICardGroupDiscounts[]> => {
    return httpRepository.postAsync<any, ICardGroupDiscounts[]>(
      `/dispositivo/cartaocashless/buscarDescontosPorCartao`,
      { localClienteId, historicoAssociacaoId, tag }
    );
  };

  /**
   * Consumacao minima IDs estabelecimentos
   * @param historicoAssociacaoId
   * @param localId
   * @param cardId
   * @returns
   */
  const getExtractData = async (
    historicoAssociacaoId: string,
    localId: string,
    cardId: string,
    isPosPaidAndMinConsuption: boolean
  ): Promise<IExtract> => {
    addLog &&
      addLog("Request getExtractData", {
        historicoAssociacaoId,
        cardId,
        isPosPaidAndMinConsuption,
      });
    if (isPosPaidAndMinConsuption) {
      const responseParsed = await extractService.getOldExtract(
        cardId,
        localId
      );
      return responseParsed;
    } else {
      const responseParsed = await extractService.getSummaryExtract(
        historicoAssociacaoId,
        localId
      );
      return responseParsed;
    }
  };

  const getExtract = async (
    historicoAssociacaoId: string,
    localId: string,
    cardId: string,
    isPosPaidAndMinConsuption: boolean
  ): Promise<CommandEletronicExtract> => {
    addLog &&
      addLog("Request getExtract", {
        historicoAssociacaoId,
        cardId,
        isPosPaidAndMinConsuption,
      });
    if (isPosPaidAndMinConsuption) {
      const responseParsed = await extractService.getExtract(cardId, localId);
      return responseParsed;
    } else {
      const responseParsed = await extractService.getSummaryExtractWithoutParse(
        historicoAssociacaoId,
        localId
      );
      return responseParsed;
    }
  };

  const getOrdPads = async (localId: string): Promise<IOrderPad[]> => {
    return await httpRepository.getAsync<IOrderPad[]>(
      `/dispositivo/${localId}/comandas`
    );
  };

  const validateAccount = async (
    params: IAccountValidationRequest
  ): Promise<IAccountValidationResponse> => {
    return await httpRepository.postAsync(
      "/CommandEletronic/ValidatePaymentAccount",
      params
    );
  };

  const payAccount = async (
    params: IPayAccountRequest
  ): Promise<IPayAccountResponse> => {
    return await httpRepository.postAsync(
      "/CommandEletronic/PayAccount",
      params
    );
  };

  const rechargeAccount = async (
    params: IRechargeAccountRequest
  ): Promise<string> => {
    return await httpRepository.postAsync(
      "/PreCashlessOnline/RechargeAccount",
      params
    );
  };

  const rechargeOfflineAccount = async (
    params: IRechargeAccountRequest
  ): Promise<string> => {
    return await httpRepository.postAsync(
      "/PreCashlessOffline/RechargeAccount",
      params
    );
  };

  const rechargeOfflineAccountOpenAccount = async (
    params: IRechargeAccountRequest
  ): Promise<string> => {
    return await httpRepository.postAsync(
      "/PreCashlessOffline/OpenAccount",
      params
    );
  };

  const doPospaidConsumption = async (
    consumptionOrder: DadosConsumoPOS
  ): Promise<{ orderId: string }> => {
    addLog && addLog("Request doConsumption", { consumptionOrder });
    return await httpRepository.postAsync(
      "/CommandEletronic/ConsumeOrder",
      consumptionOrder
    );
  };

  const doPrepaidConsumption = async (
    consumptionOrder: DadosConsumoPOS
  ): Promise<string> => {
    addLog && addLog("Request doConsumption", { consumptionOrder });
    return await httpRepository.postAsync(
      "/PreCashlessOnline/ConsumeOrder",
      consumptionOrder
    );
  };

  const getPendingRecharge = async (
    card: IGetPendingRecords
  ): Promise<IPendingRecordsResposne> => {
    addLog && addLog("Request getPendingRecharge", { card });
    // const result = await httpRepository.postAsync<IGetPendingRecords, IPendingRecordsResposne>("https://162afb2aab7d.ngrok.app/Promptus.Meep.Server/api/PreCashlessOffline/GetPendingRecharges", card);
    const result = await httpRepository.postAsync<
      IGetPendingRecords,
      IPendingRecordsResposne
    >("/PreCashlessOffline/GetPendingRecharges", card);
    return result;
  };
  
  const confirmPendingRecord = async (
    orderId: string[]
  ): Promise<IConfirmRecordResponse> => {
    addLog && addLog("Request confirmPendingRecord", { orderId });
    const payload: IConfirmRecordRequest = {
      ordersId: orderId,
    };
    // const result = await httpRepository.postAsync<IConfirmRecordRequest, IConfirmRecordResponse>("https://c763fdaa6b8e.ngrok.app/Promptus.Meep.Server/api/PreCashlessOffline/ConfirmePendingRecharges", payload);
    const result = await httpRepository.postAsync<
      IConfirmRecordRequest,
      IConfirmRecordResponse
    >("/PreCashlessOffline/ConfirmePendingRecharges", payload);
    return result;
  };

  const sendCashlessConsumption = async (
    order: Order,
    localClientId: string,
    tipoPagamento?: TransactionType,
    transacaoAdquirente?: FinancialTransactionModel,
    equipamentId?: string
  ): Promise<PedidoPos> => {
    const pedidoPos: PedidoPos = orderToPedidoPOS(
      order,
      tipoPagamento,
      transacaoAdquirente
    );

    let responseSync: responseSyncPedidoPos[] = [];

    const consumeOrder = orderToConsusmeOrder(
      pedidoPos,
      localClientId,
      equipamentId
    );

    addLog &&
      addLog("Request sendCashlessConsume", {
        ...consumeOrderToLog(consumeOrder),
        tipoPagamento,
      });

    if (tipoPagamento === TransactionType.pospaid) {
      const result = await doPospaidConsumption(
        consumeOrder
      );
      responseSync = [
        {
          pedidoPOSId: result.orderId,
        },
      ];

      if (responseSync.find((res) => res.pedidoPOSId === order.id)) {
        return pedidoPos;
      } else {
        throw GetError(
          "Falha ao validar consumo",
          "sendCashlessPospaidConsume",
          "OrderRepository"
        );
      }
    } else if (tipoPagamento === TransactionType.cashless) {
      const result = await doPrepaidConsumption(
        consumeOrder
      );
      responseSync = [
        {
          pedidoPOSId: result,
        },
      ];

      if (responseSync.find((res) => res.pedidoPOSId === order.id)) {
        return pedidoPos;
      } else {
        throw GetError(
          "Falha ao validar consumo",
          "sendCashlessPrepaidConsume",
          "OrderRepository"
        );
      }
    } else {
      throw GetError(
        "Fluxo de pagamento inválido",
        "sendCashlessConsume",
        "OrderRepository"
      );
    }
  };

  //public final String ACTIVATE_PREPAID = SERVER() + "/api/PreCashlessOffline/OpenAccount";

  const openOfflineAccount = async (
    params: IOpenAccountRequest
  ): Promise<void> => {
    return await httpRepository.postAsync(
      "/PreCashlessOffline/OpenAccount",
      params
    );
  };

  return {
    getCardData,
    getExtractData,
    getOrdPads,
    validateAccount,
    payAccount,
    rechargeAccount,
    rechargeOfflineAccount,
    rechargeOfflineAccountOpenAccount,
    doPospaidConsumption,
    doPrepaidConsumption,
    getNominalExtractByNickname,
    getGroupData,
    getPendingRecharge,
    confirmPendingRecord,
    openOfflineAccount,
    getExtract,
    sendCashlessConsumption,
  };
};
